/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTHIRDPARTYRELATIONTYPE } from './IAPTHIRDPARTYRELATIONTYPE';
import {
    IAPTHIRDPARTYRELATIONTYPEFromJSON,
    IAPTHIRDPARTYRELATIONTYPEFromJSONTyped,
    IAPTHIRDPARTYRELATIONTYPEToJSON,
} from './IAPTHIRDPARTYRELATIONTYPE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { ThirdPartyViewModel } from './ThirdPartyViewModel';
import {
    ThirdPartyViewModelFromJSON,
    ThirdPartyViewModelFromJSONTyped,
    ThirdPartyViewModelToJSON,
} from './ThirdPartyViewModel';

/**
 * 
 * @export
 * @interface ThirdPartiesSectionViewModel
 */
export interface ThirdPartiesSectionViewModel {
    /**
     * 
     * @type {IAPTHIRDPARTYRELATIONTYPE}
     * @memberof ThirdPartiesSectionViewModel
     */
    thirdPartyRelationType?: IAPTHIRDPARTYRELATIONTYPE;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof ThirdPartiesSectionViewModel
     */
    hasThirdParties?: IAPYESORNO;
    /**
     * 
     * @type {number}
     * @memberof ThirdPartiesSectionViewModel
     */
    thirdPartiesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThirdPartiesSectionViewModel
     */
    enforceAtLeastOneThirdParty?: boolean;
    /**
     * 
     * @type {Array<ThirdPartyViewModel>}
     * @memberof ThirdPartiesSectionViewModel
     */
    thirdParties: Array<ThirdPartyViewModel>;
}

/**
 * Check if a given object implements the ThirdPartiesSectionViewModel interface.
 */
export function instanceOfThirdPartiesSectionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "thirdPartiesCount" in value;
    isInstance = isInstance && "thirdParties" in value;

    return isInstance;
}

export function ThirdPartiesSectionViewModelFromJSON(json: any): ThirdPartiesSectionViewModel {
    return ThirdPartiesSectionViewModelFromJSONTyped(json, false);
}

export function ThirdPartiesSectionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThirdPartiesSectionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'thirdPartyRelationType': !exists(json, 'ThirdPartyRelationType') ? undefined : IAPTHIRDPARTYRELATIONTYPEFromJSON(json['ThirdPartyRelationType']),
        'hasThirdParties': !exists(json, 'HasThirdParties') ? undefined : IAPYESORNOFromJSON(json['HasThirdParties']),
        'thirdPartiesCount': json['ThirdPartiesCount'],
        'enforceAtLeastOneThirdParty': !exists(json, 'EnforceAtLeastOneThirdParty') ? undefined : json['EnforceAtLeastOneThirdParty'],
        'thirdParties': ((json['ThirdParties'] as Array<any>).map(ThirdPartyViewModelFromJSON)),
    };
}

export function ThirdPartiesSectionViewModelToJSON(value?: ThirdPartiesSectionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ThirdPartyRelationType': IAPTHIRDPARTYRELATIONTYPEToJSON(value.thirdPartyRelationType),
        'HasThirdParties': IAPYESORNOToJSON(value.hasThirdParties),
        'ThirdPartiesCount': value.thirdPartiesCount,
        'EnforceAtLeastOneThirdParty': value.enforceAtLeastOneThirdParty,
        'ThirdParties': ((value.thirdParties as Array<any>).map(ThirdPartyViewModelToJSON)),
    };
}

